import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { BuildingStorefrontIcon, PaintBrushIcon } from '@heroicons/react/24/outline';

import ModuleTemplateSelectionPanel from './ModuleTemplateSelectionPanel';
import ElementSelectionPanel from './ElementSelectionPanel';

const ModularSidebar = ({
    templates,
    isCanvasEmpty,
    onSelectElementType,
    selectedElementType,
    activeMode
}) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('modules'); // 'modules' или 'elements'

    const tabs = [
        { id: 'modules', label: t('toolbar.add_module'), icon: BuildingStorefrontIcon },
        { id: 'elements', label: t('elementSelectionPanel.title'), icon: PaintBrushIcon },
    ];

    const panelVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.2 } },
        exit: { opacity: 0, x: -20, transition: { duration: 0.15 } },
    };

    return (
        <div className="flex flex-col h-full w-[480px] bg-card-bg-light border-r border-gray-300">
            {/* Навигация по вкладкам */}
            <div className="flex-shrink-0 p-2 bg-gray-100 border-b border-gray-200">
                <div className="flex items-center space-x-1 bg-gray-200 p-1 rounded-lg">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => {
                                // Сбрасываем выбранный элемент при переключении вкладок
                                if (activeTab !== tab.id && selectedElementType) {
                                    onSelectElementType(null);
                                }
                                setActiveTab(tab.id);
                            }}
                            className={`w-full flex items-center justify-center px-3 py-2 text-sm rounded-md font-medium transition-colors duration-150
                                ${activeTab === tab.id
                                    ? "bg-primary-blue text-white shadow-sm"
                                    : "text-gray-700 hover:bg-gray-300 hover:text-gray-900"
                                }`}
                        >
                            <tab.icon className="w-5 h-5 mr-2" />
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Контейнер для контента вкладок */}
            <div className="flex-grow overflow-y-auto">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeTab}
                        variants={panelVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="h-full" // Убеждаемся, что дочерний элемент может занять всю высоту
                    >
                        {activeTab === 'modules' && (
                            <ModuleTemplateSelectionPanel
                                templates={templates}
                                isCanvasEmpty={isCanvasEmpty}
                            />
                        )}
                        {activeTab === 'elements' && (
                            <ElementSelectionPanel
                                onSelectElementType={onSelectElementType}
                                selectedElementType={selectedElementType}
                                activeMode={activeMode}
                            />
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};

export default ModularSidebar;